import {
  CoverLevelOptionSelector,
  CoverOptionItem,
  getCurrentQuote,
  isMatchingCoverLevelOption,
  Proposal,
} from '../../../../domain'
import { getCombinedCoverOptionItemView } from './getCombinedCoverOptionItemView'

export type ProposalProviderActions =
  | { type: 'SELECT_COVER_OPTION'; payload: CoverLevelOptionSelector }
  | { type: 'UPDATE_COVER_ITEM'; payload: { coverOption: string; active?: boolean } }
  | { type: 'UPDATE_PROPOSAL'; payload: Proposal }

export const reducer = (
  proposal: Proposal,
  { type, payload }: ProposalProviderActions,
) => {
  const quote = getCurrentQuote(proposal)

  switch (type) {
    case 'SELECT_COVER_OPTION': {
      const isMatch = isMatchingCoverLevelOption(payload)

      return {
        ...proposal,
        quote: {
          ...quote,
          availableCoverLevelOptions: quote.availableCoverLevelOptions.map((option) => ({
            ...option,
            active: isMatch(option),
          })),
        },
      } satisfies Proposal
    }

    case 'UPDATE_COVER_ITEM':
      return {
        ...proposal,
        quote: {
          ...quote,
          availableCoverLevelOptions: quote.availableCoverLevelOptions.map((option) => ({
            ...option,
            coverOptionItems: option.coverOptionItems.map(
              (item) =>
                ({
                  ...item,
                  active:
                    item.coverOption === payload.coverOption
                      ? payload.active
                      : item.active,
                } satisfies CoverOptionItem),
            ),
          })),
        },
      } satisfies Proposal

    case 'UPDATE_PROPOSAL': {
      const quote = getCurrentQuote(payload)
      const combinedCoverOptionItem = getCombinedCoverOptionItemView(quote)

      return {
        ...payload,
        quote: {
          ...payload.quote,
          availableCoverLevelOptions: payload.quote.availableCoverLevelOptions.map(
            (option) => ({
              ...option,
              coverOptionItems: option.coverOptionItems.map(combinedCoverOptionItem),
            }),
          ),
        },
      } satisfies Proposal
    }

    default:
      return proposal
  }
}
